module.exports = __webpack_public_path__ + "a65003aeb58d133d1efa462d227ee392.gif";